// extracted by mini-css-extract-plugin
export default {"vCard":"Vcard_vCard__8W5lK"};